import { render, staticRenderFns } from "./Update-Phone.vue?vue&type=template&id=2b14953c&"
import script from "./Update-Phone.vue?vue&type=script&lang=js&"
export * from "./Update-Phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports